export default __webpack_public_path__ + "static/media/sad_.74c290e2.svg";